import React, { useState } from "react";
import { error } from "../../assets";
import { Link } from "react-router-dom";
import { GrFormNextLink } from "react-icons/gr";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import { Loader } from "../../constance";


const MostView = ({ item }) => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  console.log(item, "item")
  const handleSubmit = (e) => {
    e.preventDefault();
    if (email === ' ' || !email) {
      toast.error("Please Enter Email", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
    setLoading(true);

    const productData = {
      email: email,
      products: item,
    };


    if (email) {

      axios
        .post(`/test/send-email`, productData)
        .then((res) => {
          setLoading(false);
          console.log("res", res?.data)
          setEmail('')
          toast.success(res?.data?.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
          });
        })
        .catch((error) => {
          console.error("There was an error adding the product:", error);
          setLoading(false);
          toast.error("Failed to send email", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
          });
        });
    }

  };
  return (
    <div>
      <ToastContainer />
      {loading && <Loader loading={loading} />}
      <div className=" md:flex items-center  ">
        {item?.map((x, i) => (
          <div key={i} className="w-full md:w-1/3 rounded-md">
            <div className="mx-auto flex justify-center items-center my-5">
              <img
                src={x?.photo ? x?.photo : error}
                alt="photo"
                className="w-full h-[190px] object-contain"
              />
            </div>
            <div className="flex flex-col justify-center items-center my-5 ">
              <div className="px-2 text-xl rounded-md">{x?.title}</div>
              <div className="px-2 my-2 text-primary text-xl rounded-md">
                € {x?.price}
              </div>
              <Link to={x?.link} target="_blank">
                <button className="text-center flex gap-1 rounded-lg bg-[#91C051] px-8 py-2 mt-5 text-white">
                  Read More
                  <GrFormNextLink className="text-2xl" />
                </button>
              </Link>
            </div>
          </div>
        ))}
      </div>
      <div className="max-w-[70vw] flex my-10 justify-center items-center mx-auto">
        <div className="flex flex-col">

          <h2 className="text-xl mb-5">Is that Products you need in your Email ?</h2>

          <div className="flex w-full rounded-md overflow-hidden">
            <input
              type="email"
              placeholder="Enter Your Email"
              name="product_name"
              className="w-full px-2  border border-s rounded-s-lg text-sm flex-grow outline-none"
              value={email}
              required
              onChange={(e) => setEmail(e.target.value)}
            />
            <button
              className="bg-primary text-white px-4 border border-primary h-[40px] rounded-e-lg hover:bg-[#91C051] hover:border-[#91C051] transition duration-300"
              onClick={handleSubmit}
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </div>

  );
};

export default MostView;
